// extracted by mini-css-extract-plugin
export default {"content-wrapper":"privacy-policy-module--content-wrapper--e2615","contentWrapper":"privacy-policy-module--content-wrapper--e2615"};